/**
 * PROPRIETARY AND CONFIDENTIAL
 * Copyright © 2026 Contractor Co-Pilot. All Rights Reserved.
 *
 * Screenshot slot — renders image when available, nothing when not
 */

"use client";

import Image from "next/image";
import { FadeIn } from "@/components/landing/primitives/fade-in";

export function ScreenshotSlot({
  path,
  alt,
  className = "",
}: {
  path?: string;
  alt?: string;
  className?: string;
}) {
  if (!path) return null;

  return (
    <FadeIn
      className={`rounded-xl overflow-hidden border border-border/40 shadow-lg ${className}`}
    >
      <Image
        src={path}
        alt={alt || "Product screenshot"}
        width={1200}
        height={800}
        className="w-full h-auto"
        quality={90}
      />
    </FadeIn>
  );
}
